// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_4g-0";
export var orangeButton = "_4g-1";